module.exports = __webpack_public_path__ + "img/m-hoc.75ed20aa.webp";